import React from 'react';
import styles from './OurPlatformIncludes.module.css';
import { OptimizedMotionH1 } from '../../../shared/ui/optimized-motion/OptimizedMotion';

const OurPlatformIncludes: React.FC = () => {
    return (
        <section className={styles.platformSection}>
            {/* Main content container */}
            <div className={styles.contentContainer}>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    <span className={styles.titleHighlight}>Our Platform </span>{' '}
                    <span className={styles.wrenchIcon}>🛠️</span> Includes
                </OptimizedMotionH1>

                <div className={styles.featuresGrid}>
                    {/* Brand-Voice Intelligence */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>📢</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>Brand‑Voice Intelligence</h3>
                            <p className={styles.featureDescription}>
                                Our proprietary AI learns your unique tone and style during
                                onboarding and continuously evolves with your brand.
                            </p>
                        </div>
                    </div>

                    {/* End-to-End Content Automation */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>⚙️</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>End-to-End Content Automation</h3>
                            <p className={styles.featureDescription}>
                                Over 50 tasks automated—from ideation to publishing—so your team can
                                focus on strategy and creativity.
                            </p>
                        </div>
                    </div>

                    {/* Collaborative Workspace */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>🤝</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>Collaborative Workspace</h3>
                            <p className={styles.featureDescription}>
                                One central hub with real-time editing, role-based permissions, and
                                version control that keeps your team in sync.
                            </p>
                        </div>
                    </div>

                    {/* Streamlined Approvals */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>✅</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>Streamlined Approvals</h3>
                            <p className={styles.featureDescription}>
                                Multi-tiered, click-to-approve workflows reduce bottlenecks and
                                create a clear audit trail for every asset.
                            </p>
                        </div>
                    </div>

                    {/* Performance Analytics */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>📊</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>Performance Analytics</h3>
                            <p className={styles.featureDescription}>
                                See what works and why. Our dashboards tie performance to voice,
                                tone, and creative variables so you can optimize with confidence.
                            </p>
                        </div>
                    </div>

                    {/* Industry-Specific Templates */}
                    <div className={styles.featureCard}>
                        <div className={styles.iconContainer}>
                            <span className={styles.icon}>📂</span>
                        </div>
                        <div className={styles.cardContent}>
                            <h3 className={styles.featureTitle}>Industry-Specific Templates</h3>
                            <p className={styles.featureDescription}>
                                Launch faster with customizable content templates for over 30
                                industries—perfectly aligned with your goals and voice.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurPlatformIncludes;
